<template>
  <div class="learingPerson" style="margin-top:-33px;">
    <!-- 顶部头像和设置 -->
    <div class="top">
      <div class="info">
        <div class="avatar-wrapper">
          <img src="../assets/lazyload.png">
        </div>

        <div class="name-wrapper">
          <span class="name" v-show="$store.state.mineStore.userId==''"  @click="login">登录</span>
          <span class="name" v-show="$store.state.mineStore.userId!=''">{{$store.state.mineStore.userName}}</span>
          <span class="desc" v-show="$store.state.mineStore.userId!=''" @click="logout">退出登录 <i class="iconfont icon-more"></i></span>
        </div>
      </div>

      <div class="operation">
        <i class="iconfont icon-huanfu"></i>
        <i class="iconfont icon-youjian"></i>
        <i class="iconfont icon-shezhi"></i>
      </div>
    </div>

    <!-- 横线分隔条 -->
    <!-- <crossLine></crossLine> -->

    <!-- 重要的栏目 -->
    <!-- <div class="important"  @click = "go('personCollect')">
      <crossItem name="我的收藏">
        <i class="iconfont icon-shoucang1"></i>
      </crossItem>

    </div> -->

    <!-- 横线分隔条 -->
    <!-- <crossLine></crossLine> -->

    <!-- 次要的栏目 -->
    <div class="minor" @click = "go('about')">
      <crossItem name="关于我们">
        <i class="iconfont icon-daohangguanyu"></i>
      </crossItem>
    </div>

    <!-- 横线分隔条 -->
    <crossLine v-show="$store.state.mineStore.role=='student'"></crossLine>

    <div v-show="$store.state.mineStore.role=='student'" class="minor" @click = "go('record')">
      <crossItem name="登录记录">
        <i class="iconfont icon-daohangguanyu"></i>
      </crossItem>
    </div>

    <!-- 横线分隔条 -->
    <crossLine v-show="$store.state.mineStore.role=='holder'"></crossLine>

    <div v-show="$store.state.mineStore.role=='holder'" class="minor" @click = "go('all')">
      <crossItem name="数据汇总">
        <i class="iconfont icon-daohangguanyu"></i>
      </crossItem>
    </div>

    <!-- 次要的栏目 -->
    <!-- <div class="minor">
      <div class="show-guide">
        <span style="line-height:44px;height:44px;padding-left:30px;">显示引导页</span>
        <mt-switch style="position:absolute;right:0px;top:6px;width:80px;" v-model="ifShowGuide" @change="onChange"></mt-switch>
      </div>
    </div> -->

    <!-- 横线分隔条 -->
    <!-- <crossLine v-if="isApp"></crossLine> -->

    <!-- 次要的栏目 -->
    <!-- <div class="minor" @click = "go('update')" v-if="isApp">
      <crossItem name="版本更新">
        <i class="iconfont icon-daohangguanyu"></i>
      </crossItem>
    </div> -->

  </div>
  </div>
</template>
<script>
// import httpCt from "../api/httpClient";
// import IndexApi from "../api/learingInd.js";
import store from "@/store/index";
import cfg from "./../utils/config";
import crossLine from "./../components/cross-line.vue";
import crossItem from "./../components/cross-item.vue";
import { Toast, MessageBox } from "mint-ui";
export default {
  name: "learingPerson",
  data() {
    return {
      ifShowGuide: true,
      isApp: true,
      rcomData: [], // 推荐课程
      courseData: [], // 全部（首页数据分析）课程
      swipeable: "true",
      imgBaseUrl: cfg.imgBaseUrl,
      param: {}
    };
  },

  methods: {
    onChange() {
      console.log(this.ifShowGuide);
      if(this.ifShowGuide==true){
        localStorage.setItem("ifShowGuide", "on");
      }else{
        localStorage.setItem("ifShowGuide", "off");
      }
      
    },
    go(type) {
      if (type == "personCollect") {
        if (this.$store.state.mineStore.isLogin == false) {
          Toast({
            message: "请先登录",
            position: "bottom",
            duration: 800
          });
          return;
        }
      }
      this.$router.push("./" + type);
    },
    login() {
      this.$router.push({
        path: "/login/"
      });
    },
    logout() {
      let that = this;
      MessageBox.confirm("确认退出登录？")
        .then(action => {
          if (action == "confirm") {
            //确认的回调
            console.log(1);
            this.$store.commit("updateUserId", "");
            this.$store.commit("updateUserNumber", "");
            this.$store.commit("updateUserName", "");
            this.$store.commit("updateRole", "");
            this.$store.commit("updateIsLogin", false);
            this.$store.commit("updateLoginTime", "");
          }
        })
        .catch(err => {
          if (err == "cancel") {
            //取消的回调
            console.log(2);
          }
        });
    }
  },
  created() {
    console.log("created");
    console.log(localStorage.getItem("ifShowGuide"));
    //判断引导页显示选项初始值
    //如果没有值，或是为true  显示
    if (
      localStorage.getItem("ifShowGuide") == null ||
      localStorage.getItem("ifShowGuide") == undefined ||
      localStorage.getItem("ifShowGuide") == "on"
    ) {
      this.ifShowGuide = true;
    }
    //如果为false，不显示
    if (localStorage.getItem("ifShowGuide") == "off") {
      this.ifShowGuide = false;
    }
  },
  mounted: function() {
    try {
      mui;
    } catch (error) {
      console.log("plus not");
      this.isApp = false;
    }
  },
  components: {
    crossLine,
    crossItem
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/baseScss";
.show-guide {
  vertical-align: middle;
  color: #333;
  height: 44px;
  line-height: 44px;
  background: #fff;
  border-bottom: 1px solid #e4e4e4;
  // margin: 0 15px;
  padding: 0 10px;
  position: relative;
}

.cross-line {
  height: 5px !important;
}

.top {
  display: flex;
  position: relative;
  width: 100%;
  height: 120px;
  background-color: #e70101;
  .info {
    flex: 2;
    display: flex;
    flex-direction: row;
    margin-top: 40px;
    .avatar-wrapper {
      width: 70px;
      height: 70px;
      margin-left: 20px;
      img {
        width: 70px;
        height: 70px;
        border-radius: 50%;
      }
    }
    .name-wrapper {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      height: 55px;
      margin-top: 10px;
      margin-left: 20px;
      .name {
        font-size: 16px;
        color: #fff;
        font-weight: bold;
      }
      .desc {
        font-size: 16px;
        color: #fcfefe;
        i {
          font-size: 18px;
        }
      }
    }
  }
  .operation {
    flex: 1;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    i {
      margin-top: 10px;
      margin-right: 15px;
      color: #fff;
      font-size: 18px;
      font-weight: 500;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/module-person/index.vue